const t = {
  name: "ArrowLeftRight",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.41439 6.00012L9.41436 2.00015L8.00015 0.585938L1.58594 7.00015L8.00015 13.4144L9.41436 12.0002L5.41434 8.00012H23V6.00012H5.41439Z" fill="currentColor"/>
<path d="M22.4144 17.0002L16.0002 10.5859L14.5859 12.0002L18.5859 16.0001L1 16.0001V18.0001L18.586 18.0001L14.5859 22.0002L16.0002 23.4144L22.4144 17.0002Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ArrowLeftRight
};
